// What the Change History lists call each audit row (settings History tab and
// /admin/history). The order-edit rows are written by server/orderEditAudit.ts.
export const AUDIT_ACTION_LABELS: Record<string, string> = {
  quantity_changed: "Quantity Changed",
  price_changed: "Price Changed",
  item_added: "Line Added",
  item_removed: "Line Removed",
  notes_changed: "Notes Changed",
  status_changed: "Status Changed",
  fulfillment_changed: "Fulfillment Changed",
  delivery_location_changed: "Location Changed",
  order_deleted: "Order Deleted",
  customer_cancelled_order: "Order Cancelled",
  procurement_reset: "Procurement Reset",
  authorized_contact_added: "Contact Added",
  authorized_contact_removed: "Contact Removed",
};

export function auditActionLabel(action: string): string {
  return AUDIT_ACTION_LABELS[action] ?? action;
}
